import { required, maxLength, email } from "@vuelidate/validators";

export default class Responsible {
  constructor(data) {
    this.id = data.id != null ? data.id : null;
    this.name = data.name != null ? data.name : null;
    this.cpf = data.cpf != null ? data.cpf : null;
    this.credential = data.credential != null ? data.credential : null;
    this.contact = data.contact != null ? data.contact : null;
    this.email = data.email != null ? data.email : null;
    this.person = data.person != null ? data.person : null;
    this.status = data.status != null ? data.status : true;
  }

  toJson() {
    return {
      id: this.id,
      email: this.email,
      person: this.person,
      status: this.status,
    };
  }

  validations() {
    return {
      credential: {
        required,
      },
      email: {
        required,
        maxLength: maxLength(100),
        email,
      },
    };
  }
}
